import { GetCurrencySchema, z } from '../index.ts'

export const GetInquiryLoadRateSchema = z.object({
  admin_rate: z.number(),
  currency: z.string(),
  customer_rate: z.number(),
  default: z.boolean(),
})

export const GetInquiryLoadRatesSchema = z.object({
  EUR: GetInquiryLoadRateSchema,
  GBP: GetInquiryLoadRateSchema,
  PLN: GetInquiryLoadRateSchema,
  USD: GetInquiryLoadRateSchema,
})

export const GetLoadRateSchema = z.object({
  base_line_cost: z.number(),
  cost: z.number(),
  currency: GetCurrencySchema,
  default: z.boolean(),
  historical_rate: z.number(),
  offered_rate: z.number(),
  preferred_rate: z.number(),
  profit: z.number(),
  rate: z.number(),
})

export const GetLoadRatesSchema = z.object({
  EUR: GetLoadRateSchema,
  GBP: GetLoadRateSchema,
  PLN: GetLoadRateSchema,
  USD: GetLoadRateSchema,
})

export const GetCustomAttributesSchema = z.object({
  export: z.enum(['0', '1']).nullish(),
  import: z.enum(['0', '1']).nullish(),
  ipaff: z.enum(['0', '1']).nullish(),
})
